import React from "react";
import Heading from "../../components/Heading";
import FeaturesCart from "../WebsiteDevelopment/FeaturesCart"
const Services1 = () => {
  return (
    <div className="py-[5%]">
      <div className="text-center leading-[28px] mx-[7%] ">
        <Heading content="ENSURE OPTIMAL BRANDING OUTCOMES WITH PPC ADVERTISING BY MAKING INFORMED DECISIONS" />
      </div>

      <div className="flex flex-wrap justify-center py-[2%] mx-[5%]">
        <FeaturesCart
          content={
            "One of the biggest benefits of PPC advertising is its ability to provide immediate results. Advertisers can launch a campaign and start seeing traffic ."
          }
          img="/Images/SearchAds.png"
          heading={"Search Ads"}
        />
        <FeaturesCart
          content={
            "Display ads can be purchased through various advertising networks, such as Google Display Network, Facebook Ads, and LinkedIn Ads."
          }
          img="/Images/DisplayAds.png"
          heading={"Display Ads"}
        />
        <FeaturesCart
          content={
            "Social ads offer businesses the opportunity to reach a highly engaged and targeted audience, as social media platforms collect a wealth of data on their users' interests."
          }
          img="/Images/SocialAds1.png"
          heading={"Social Ads"}
        />
        <FeaturesCart
          content={
            "Remarketing ads work by placing a cookie on a user's browser when they visit a website or app. remarketing ads can also be seen as intrusive or annoying if not executed properly. "
          }
          img="/Images/RemarketingAds1.png"
          heading={"Remarketing Ads"}
        />
        <FeaturesCart
          content={
            "Google Shopping ads are suitable for websites with a large volume of products. These PPC ads appear in a carousel above or beside the main Google search results, allowing"
          }
          img="/Images/GoogleShoppingAds.png"
          heading={"Google Shopping Ads"}
        />
        <FeaturesCart
          content={
            "In-stream ads are also called YouTube ads. These are pay-per-click ads that appear on YouTube search results, YouTube videos and video partners on Display Network."
          }
          img="/Images/In-streamAds.png"
          heading={"In-stream Ads"}
        />
      </div>
    </div>
  );
};

export default Services1;
